import * as angular from 'angular';

import { ComponentDefinition } from '../../../models';
import { HeaderInfo } from '../HeaderInfo';

class PrintCompactHeaderController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    
    readonly headerInfo: HeaderInfo; // Assumed

    static $inject = [];
}

export const wtPrintCompactHeader: ComponentDefinition = {
    componentId: 'wtPrintCompactHeader',
    controller: PrintCompactHeaderController,
    template: require('./printCompactHeader.component.html'),
    controllerAs: 'vm',
    bindings: {
        headerInfo: '<'
    }
};